class MainProductContext extends HTMLElement {
  constructor() {
    super();
    this.productOptions = this.querySelector('main-product-options');
    this.productHandle = this.getAttribute('product-handle');
    this.upsellCheckboxes = this.querySelectorAll('upsell-checkbox');
    this.productForm = this.querySelector('product-form');
  }

  upsellProducts = [];

  connectedCallback() {
    if (this.productOptions) {
      this.productOptions.addEventListener('variant-change', this.handleOptionChange.bind(this));
    }
    if (this.upsellCheckboxes) {
      this.upsellCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('upsell-checkbox-change', this.handleUpsellCheckboxChange.bind(this));
      });
    }
  }

  handleOptionChange(event) {
    this.currentVariant = event.detail;
    if (this.currentVariant) {
      this.updateSections();
    }
  }

  handleUpsellCheckboxChange(event) {
    if (event.detail.checked) {
      this.upsellProducts.push(event.detail.productId);
    } else {
      this.upsellProducts = this.upsellProducts.filter((productId) => productId !== event.detail.productId);
    }
    this.productForm.upsellProducts = this.upsellProducts;
  }

  updateSections() {
    const sectionsString = this.getSectionsToRender().map((section) => {
      return section.section;
    }).join(',');

    const request = new XMLHttpRequest();
    request.addEventListener('load', (event) => {
      try {
        this.handleSectionsResponse(event);
      } catch (error) {
        console.error(error);
      }
    });
    
    request.addEventListener('error', () => {
      console.error('Failed to load sections');
    });

    request.open('GET', `${window.Shopify.routes.root}products/${this.productHandle}?variant=${this.currentVariant.id}&sections=${sectionsString}`, true);
    request.send();
  }

  handleSectionsResponse(event) {
    const sections = JSON.parse(event.target.response);
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
    });
    this.dispatchEvent(new CustomEvent('sections-rendered', { 
      detail: { sections }, 
      bubbles: true 
    }));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-product-images',
        section: 'main-product-images',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-info',
        section: 'main-product-info',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-info-mobile',
        section: 'main-product-info-mobile',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-bundle-slider',
        section: 'main-product-bundle-slider',
        selector: '.shopify-section',
      },
      {
        id: 'main-product-form',
        section: 'main-product-form',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('main-product-context', MainProductContext);